var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBlockPositionEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,0h18c1.7,0,3,1.3,3,3v18c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V3C0,1.3,1.3,0,3,0z M21,22c0.6,0,1-0.4,1-1V3 c0-0.6-0.4-1-1-1H3C2.4,2,2,2.4,2,3v18c0,0.6,0.4,1,1,1H21z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,4c0.8,0,1.5,0.7,1.5,1.5v13c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5v-13C16.5,4.7,17.2,4,18,4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlockPositionEnd);
export default __webpack_public_path__ + "static/media/icon-block-position-end.b035ce2e9ce15ab7d5798ff94821a150.svg";
export { ForwardRef as ReactComponent };